module.exports = __webpack_public_path__ + "img/logo.43e0f3fd.png";